/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {

    export class PagingModel<T> {
        private itemsArray: Array<T>;
        private items: Array<T>;

        public itemsPerPage: number;
        public currentPage: number;
        

        constructor(itemsArray: Array<T>, itemsPerPage: number, currentPage?: number) {
            this.itemsArray = itemsArray;
            this.itemsPerPage = itemsPerPage;
            this.currentPage = currentPage ? currentPage : 1;
            this.updateItems();
        }

        public updateItems() : void {
            var beginIndex = ((this.currentPage - 1) * this.itemsPerPage) - 1;
            var endIndex = beginIndex + this.itemsPerPage + 1;
            this.items = this.itemsArray.slice(beginIndex, endIndex);
        }

        // This is a function to ensure the correct count is returned in case the items array is modified after the constructor call
        public getTotalItems(): number {
            return this.itemsArray ? this.itemsArray.length : 0;
        }

        // This is a function to ensure the correct items are returned in case the items array is modified after the constructor call
        public getCurrentPage(): Array<T> {
            this.updateItems();
            return this.items;
        }
    }
}